import { UserFragment } from '../user';
export const MediaFragment = `
	fragment MediaFragment on Media {
		id
		filename
		originalFilename
		size
		type
		user {
			...UserFragment
		}
		account {
			id
		}
		status
		createdAt
		updatedAt
	}
	${UserFragment}
`;
